// This file is auto-generated by online/ops/maven/online-maven-plugin

export enum ApiVerb {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

// UI API specific type that is evaluated out of the endpoints that have it, luckily this is our
// generator so we can have things like this!
export interface LimitableQuery {
  limit?: number;
  offset?: number;
}

export interface SortableLimitableQuery extends LimitableQuery {
  order?: string;
  sort?: string;
}

export enum ApiType {
  
  PRIVATE = 'Private',
  PUBLIC = 'Public',

}

export interface ApiMethod {
  path: string;
  type: ApiType;
  verb: ApiVerb;
}

const replacePathParams = (path: string, pathParams: { [param: string]: string }): string => {
  let processedPath = path;
  for (let param of Object.keys(pathParams)) {
    if (pathParams.hasOwnProperty(param)) {
      processedPath = processedPath.replace(`{${param}}`, pathParams[param]);
    }
  }
  return processedPath;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getQueryString = (query?: {[param: string]: any}): string => {
  let queryString = '';
  if (query) {
    for (let param of Object.keys(query)) {
      if (query.hasOwnProperty(param) && query[param] !== undefined && query[param] !== null) {
        if (!queryString) {
          queryString += '?';
        } else {
          queryString += '&';
        }
        queryString += param + '=' + encodeURIComponent(String(query[param]));
      }
    }
  }
  return queryString;
}



export const prepareLoginPublicMethod = (query: {  callPath: string; locale: string; changeContext?: boolean; noPrompt?: boolean; invitationId?: string; includeAdmins?: boolean; noContextClient?: boolean; register?: boolean; migrate?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/prepare-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const processLoginPublicMethod = (query: {  code: string; state: string; error?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/process-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const validateSessionPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/validate',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const logoutPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/logout',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelsByAddressPublicMethod = (query: {  subscriptionType: string; addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/online-models' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const submitChatFeedbackPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/chat/feedback',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const validateChatTokenPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/chat/validate',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const getChatSchedulePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/chat/schedule',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getInvitationPublicMethod = (invitationId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/public/invitations/{invitationId}', {invitationId: invitationId,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getVaihtoetuItemGroupsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/vaihtoetu/itemgroups',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getVaihtoetuManufacturersPublicMethod = (query: {  itemGroupId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/vaihtoetu/manufacturers' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getVaihtoetuModelsPublicMethod = (query: {  manufacturerId: number; itemGroupId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/vaihtoetu/models' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getVaihtoetuGradingFormPublicMethod = (id: number): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/public/vaihtoetu/models/{id}/grading-form', {id: String(id),}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const submitVaihtoetuPriceQuotePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/vaihtoetu/price-quote',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const submitAnonymousLeadPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/leads',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const searchPublicSitePublicMethod = (query: {  query: string; pageSize?: number; pageToken?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/public-site/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getNavigationV3PublicMethod = (query?: {  locale?: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/navigation' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelHeadersV3PublicMethod = (query: {  category: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/online-model-headers' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getCmsOnlineModelsV3PublicMethod = (query: {  category: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/cms/online-models' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getCmsInactiveOnlineModelsV3PublicMethod = (query: {  category: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/cms/online-models/inactive' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelByCodeV3PublicMethod = (onlineModelCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getPageV3PublicMethod = (query: {  path: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/pages' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductFeedByCategoryV3PublicMethod = (messageType: string, category: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/product-feed/{messageType}/{category}', {messageType: messageType,category: category,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductFeedForAllDevicesV3PublicMethod = (messageType: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/product-feed/{messageType}/all_devices', {messageType: messageType,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getSitemapV3PublicMethod = (): ApiMethod => {
  return {
    path: '/api/site/v3/public/sitemap',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getImageSitemapV3PublicMethod = (): ApiMethod => {
  return {
    path: '/api/site/v3/public/image-sitemap',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatSitemapIndexV3PublicMethod = (): ApiMethod => {
  return {
    path: '/api/site/v3/public/ideat-sitemap',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatSitemapV3PublicMethod = (type: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/ideat-sitemap/{type}', {type: type,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatArticlesV3PublicMethod = (query?: {  limit?: number; skip?: number; tag?: string; category?: string; locale?: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/ideat/articles' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatArticleV3PublicMethod = (slug: string, query?: {  locale?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/ideat/articles/{slug}', {slug: slug,}) + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatCategoryV3PublicMethod = (slug: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/ideat/categories/{slug}', {slug: slug,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatTagV3PublicMethod = (slug: string): ApiMethod => {
  return {
    path: replacePathParams('/api/site/v3/public/ideat/tags/{slug}', {slug: slug,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatHomepageConfigV3PublicMethod = (): ApiMethod => {
  return {
    path: '/api/site/v3/public/ideat/homepage-config',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getIdeatKeywordsV3PublicMethod = (query?: {  locale?: string; }): ApiMethod => {
  return {
    path: '/api/site/v3/public/ideat/keywords' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const loginWithAccountCommunityUserPrivateMethod = (accountMdmid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/auth/{accountMdmid}/login', {accountMdmid: accountMdmid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const refreshSessionPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/refresh-session',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const registerUserPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/register',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const mobileVerificationRequestPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/mobile/request',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const verifyMobileVerificationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/mobile/verify',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const requestEmailVerificationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/email/request',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const resendEmailVerificationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/email/request',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const verifyEmailVerificationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/email/verify',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const verifyEmailVerificationAndProcessInvitationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/verification/email/verify-and-process-invitation',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const finalizeCardPaymentPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/orders/finalize-card-payment',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createInvitationPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/invitations',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const listInvitationsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/invitations',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const resendInvitationPrivateMethod = (invitationId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/invitations/{invitationId}', {invitationId: invitationId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const cancelInvitationPrivateMethod = (invitationId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/invitations/{invitationId}', {invitationId: invitationId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getContactInvitationPrivateMethod = (contactMasterId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/contacts/{contactMasterId}/invitation', {contactMasterId: contactMasterId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateContactAccessRightsPrivateMethod = (contactMasterId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/contacts/{contactMasterId}/access-rights', {contactMasterId: contactMasterId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getServiceAgreementsPrivateMethod = (query: {  ssoId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/service-agreements' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const migrateUsersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/migrate',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getPrivateOnlineModelHeadersPrivateMethod = (query?: {  onlineModelCodes?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/online-model-headers' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getPrivateOnlineModelPrivateMethod = (onlineModelCode: string, query?: {  salesType?: string; voucherCode?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getEmployeeOnlineModelHeadersPrivateMethod = (query?: {  onlineModelCodes?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-employee/online-model-headers' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getPunchoutOnlineModelHeadersPrivateMethod = (query?: {  onlineModelCodes?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v3/private/punchout/online-model-headers' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getEmployeeOnlineModelPrivateMethod = (onlineModelCode: string, query?: {  salesType?: string; voucherCode?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-employee/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getPunchoutOnlineModelPrivateMethod = (onlineModelCode: string, query?: {  salesType?: string; voucherCode?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/punchout/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const batchGetCallerDisplayNamesPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/caller-display-names/batch',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const bulkUpsertCallerDisplayNamesPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/customer-admin/caller-display-names/bulk',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const deleteCallerDisplayNamePrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/caller-display-names/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const searchContactsPrivateMethod = (query?: {  phone?: string; name?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/private/contact-search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getContactSearchHistoryPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/contact-search/history',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getContactRatingPrivateMethod = (phone: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/contact-ratings/{phone}', {phone: phone,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateContactRatingPrivateMethod = (phone: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/contact-ratings/{phone}', {phone: phone,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getChangeRequestDetailsPrivateMethod = (changeRequestId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v3/private/customer-admin/change-request-details/{changeRequestId}', {changeRequestId: changeRequestId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getBulkPricesPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/bulk-prices',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const submitChatFeedbackPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/chat/feedback',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const submitLeadPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/leads',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const searchCompaniesV3PrivateMethod = (query: {  query: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/public/companies/search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchSubscriptionsV3PrivateMethod = (query: SortableLimitableQuery & {  subscriptionType: string[]; excludeCardPayment?: boolean; subscriptionSubType?: string; billingAccountRecordType?: string; paymentType?: string; excludeEpp?: boolean; deviceUser?: string; search?: string; commitmentPeriod?: string; eppFilter?: string; expiringFilter?: string; billingAccountDisplayId?: string; subscriptionContactId?: string; reporting?: boolean; }): ApiMethod => {
  return {
    path: '/api/search/v3/subscriptions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchSubscriptionAggregationsV3PrivateMethod = (query: {  subscriptionCategory: string; excludeCardPayment?: boolean; excludeEpp?: boolean; search?: string; billingAccountRecordType?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/subscription-aggregations' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const countSearchSubscriptionsV3PrivateMethod = (): ApiMethod => {
  return {
    path: '/api/search/v3/documents/subscriptions/count',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getSearchBillingAccountsV3PrivateMethod = (query?: SortableLimitableQuery & {  billingContactOrEmailReceiverId?: string; search?: string; sourceSystem?: string; billingContactId?: string; billingAccountDisplayId?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/billing-accounts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchContactsV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; contactMasterId?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchCustomerOrdersV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; customerOrderDisplayId?: string; customerOrderType?: string; selectedApproverId?: string; onlySfdcOrders?: boolean; excludeChangeRequests?: boolean; productType?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchEmployeeCustomerOrdersV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/employee-customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchSubscriptionActionsV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; subscriptionDisplayId?: string; own?: boolean; requestCreatorContactId?: string; status?: string; requesterContactId?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/subscription-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchSupportCasesV3PrivateMethod = (query?: SortableLimitableQuery & {  supportCaseDisplayId?: string; search?: string; feature?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchOpenSupportCasesV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/support-cases/open-support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchVirtualCatalogsV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; productType?: string; status?: string; contractPeriod?: string; }): ApiMethod => {
  return {
    path: '/api/search/v3/virtualCatalogs' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchInvoicesV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; openInvoicesOnly?: boolean; paidInvoicesOnly?: boolean; }): ApiMethod => {
  return {
    path: '/api/search/v3/invoices' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchInvoiceDocumentsV3PrivateMethod = (query?: SortableLimitableQuery & {  search?: string; documentType?: string[]; }): ApiMethod => {
  return {
    path: '/api/search/v3/invoices/documents' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSearchGlobalV3PrivateMethod = (query: {  query: string; searchResultTypes?: string[]; }): ApiMethod => {
  return {
    path: '/api/search/v3/global-search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDeviceVariantsPrivateMethod = (deviceType: string, query: {  category: string; sort?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/deviceVariants/{deviceType}', {deviceType: deviceType,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDeviceVariantRelatedAccessoriesPrivateMethod = (variantGroupId: string, query?: {  sourceProductOfferingIds?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/deviceVariant/{variantGroupId}/relatedAccessories', {variantGroupId: variantGroupId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOrdersPrivateMethod = (query?: LimitableQuery & {  orderType?: string; search?: string; changeType?: string; dateTo?: string; company?: string; state?: string; sort?: string; dateFrom?: string; productType?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOrderByIdPrivateMethod = (orderId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/orders/{orderId}', {orderId: orderId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOrderItemByIdPrivateMethod = (orderId: string, orderItemId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/orders/{orderId}/items/{orderItemId}', {orderId: orderId,orderItemId: orderItemId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createProductOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v4/private/productOrder',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateProductOrderPrivateMethod = (id: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{id}', {id: id,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getProposalsPrivateMethod = (query: LimitableQuery & {  filter: string; returnTotalCount?: boolean; sort?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/proposalAndAgreementManagement/proposal' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getProposalByIdPrivateMethod = (proposalId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/proposalAndAgreementManagement/proposal/{proposalId}', {proposalId: proposalId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateProposalByIdPrivateMethod = (proposalId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/proposalAndAgreementManagement/proposal/{proposalId}', {proposalId: proposalId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getProductDeliveryMethodsPrivateMethod = (query?: LimitableQuery & {  filter?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/deliveryMethods' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCustomerPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v4/private/customer',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getGeographicAddressPrivateMethod = (query: {  query: string; postCode: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/geographicAddress' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getGeographicAddressByIdPrivateMethod = (addressId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/geographicAddress/{addressId}', {addressId: addressId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getAvailableInstallationDatesPrivateMethod = (orderId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{orderId}/availableInstallationDates', {orderId: orderId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getDeliveryOptionsPrivateMethod = (orderId: string, query: {  addressId: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{orderId}/deliveryOptions', {orderId: orderId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateProductOrderDeliveryMethodPrivateMethod = (id: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{id}/delivery', {id: id,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const submitProductOrderPrivateMethod = (id: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{id}/submit', {id: id,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const initCardPaymentForProductOrderPrivateMethod = (id: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productOrder/{id}/init-card-payment', {id: id,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getBillingAccountsCocoPrivateMethod = (query?: LimitableQuery & {  fields?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/billingAccount' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createBillingAccountCocoPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v4/private/billingAccount',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getBillingAccountByIdCocoPrivateMethod = (id: string, query?: {  fields?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/billingAccount/{id}', {id: id,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getEmployeeProductListsPrivateMethod = (query: {  mdmId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/employeeProductList' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createEmployeeProductListPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v4/private/employeeProductList',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getEmployeeProductListPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductList/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const patchEmployeeProductListPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductList/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PATCH,
  };
};

export const deleteEmployeeProductListPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductList/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getEmployeeProductSelectionsPrivateMethod = (query: {  mdmId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/employeeProductSelection' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createEmployeeProductSelectionPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v4/private/employeeProductSelection',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getEmployeeProductSelectionPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductSelection/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const patchEmployeeProductSelectionPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductSelection/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PATCH,
  };
};

export const deleteEmployeeProductSelectionPrivateMethod = (uuid: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/employeeProductSelection/{uuid}', {uuid: uuid,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getProductInventoryPrivateMethod = (query?: LimitableQuery & {  user?: string; productType?: string; ba?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v4/private/productInventory' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getProductInventoryByIdPrivateMethod = (inventoryId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/private/productInventory/{inventoryId}', {inventoryId: inventoryId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const logInPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logInAndSavePrimaryAccountPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in-and-save-primary-account',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logInAndAddMissingMobileNumberPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in-and-add-missing-mobile-number',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const validatePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/validate',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const resolveMissingPrimaryAccountPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/resolve-missing-primary-account',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const prepareElisaIdV2LoginPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/prepare-elisaid-login',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const processElisaIdV2LoginPublicMethod = (query: {  authCode: string; redirectUrl: string; onboardingId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/process-elisaid-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getExternalAuthorizationRequestPublicMethod = (linkToken: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/auth/external/requests/{linkToken}', {linkToken: linkToken,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const authorizeExternalAuthorizationRequestPublicMethod = (linkToken: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/auth/external/requests/{linkToken}/authorize', {linkToken: linkToken,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const getExternalAuthenticationMethodsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/authentication-methods',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const validateExternalAuthenticationUserAuthorityPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/validate-user-authority',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const registerExternalAuthenticationUserPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/register-user',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const checkSsoUserExistsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/check-user-exists',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const verifyEmailPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/verify-email',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const resetPasswordPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/reset-password',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const validateOtpPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/validate-otp',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const sendOtpToUserPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/send-otp-to-user',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const searchCompaniesPublicMethod = (query: {  query: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/companies/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const searchPagesPublicMethod = (query: {  query: string; start: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/pages/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getAddOnRulesPublicMethod = (query?: {  subscriptionType?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/add-on-rules' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getAddOnVisibilityPublicMethod = (commercialProductCode: string, query: {  operationType: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/metadata/addon-visibility/{commercialProductCode}', {commercialProductCode: commercialProductCode,}) + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getBillChannelsPublicMethod = (query?: {  mdmId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/bill-channels' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getHolidaysPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/holidays',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const searchAddressPublicMethod = (query: {  query: string; postalCode: string; filter?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/addresses/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getCommercialAvailabilityPublicMethod = (query: {  subscriptionType: string; addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/addresses/commercial-availability' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const createAnonymousSupportCasePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/support-cases',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const createAnonymousLeadPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/leads',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const getCampaignsPublicMethod = (query: {  salesType: string; voucher: string; onlineModel: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/campaigns' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const proxyGetPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const proxyPostPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const proxyPutPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.PUT,
  };
};

export const proxyDeletePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.DELETE,
  };
};

export const getTrainingPublicMethod = (trainingId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/trainings/{trainingId}', {trainingId: trainingId,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const domainGetPublicMethod = (query: {  query: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/domains' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const punchoutLoginPublicMethod = (query: {  accountId: string; password: string; username: string; catalogName?: string; session?: string; origin?: string; customer?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/punchout/login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const licenseManagementUrlPublicMethod = (query: {  accountId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/get-license-management-url' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getLicenseManagementAccountsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/get-license-management-accounts',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const redirectCanvasRequestOpenFormPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/sf',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logOutPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/log-out',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const elisaIdV2LogOutPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/elisaid-log-out',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changePasswordPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/change-password',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const raiseAuthenticationLevelPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/raise-level',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const raiseAuthenticationLevelValidateOtpPrivateMethod = (otp: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/auth/raise-level/validate/{otp}', {otp: otp,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const resolveUserNameConflictPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/resolve-user-name-conflict',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const switchAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/switch-account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const identifyStronglyPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/identify-strongly',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getMyselfAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateMyselfAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getMyselfSecondaryAccountsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/secondary-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMyselfSecondaryAccountsCompanyInfosPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/secondary-accounts/company-infos',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMyselfUserPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/user',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getAccountKeyUsersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account/key-users',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateAccountKeyUserPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account/key-users',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getAccountKeyUsersByServiceAgreementIdPrivateMethod = (serviceAgreementId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/myself/account/key-users/{serviceAgreementId}', {serviceAgreementId: serviceAgreementId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateMyselfContactPrivateMethod = (query?: {  onboardingId?: string; forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/contact' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getMyselfChangesPrivateMethod = (query?: {  latestChangeRef?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/changes' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const resendVerifyEmailLinkPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/resend-verify-email-link',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getEppSolutionPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/company-info/epp-solution-jit-failure-workaround',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getContactsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; contactMasterId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createContactPrivateMethod = (query?: {  forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateContactPrivateMethod = (contactId: string, query?: {  bothNamesChanged?: boolean; forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}', {contactId: contactId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getContactBillingAccountsPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/billing-accounts', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createAdminUserPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/users', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const deleteAdminUserPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/users', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const checkDuplicateContactsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/duplicate-check',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const validateMoveContactPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact/validate',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const hasPendingActionsForContactPrivateMethod = (query: {  contactMasterId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact/pending-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const submitMoveContactPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createShoppingCartPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/shopping-carts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateShoppingCartPrivateMethod = (shoppingCartId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/shopping-carts/{shoppingCartId}', {shoppingCartId: shoppingCartId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const finalizeShoppingCartPrivateMethod = (shoppingCartId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/shopping-carts/{shoppingCartId}/submitted', {shoppingCartId: shoppingCartId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getBillingAccountsPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; sourceSystem?: string; billingContactId?: string; billingAccountDisplayId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/billing-accounts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateBillingAccountPrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getBillingAccountScheduledChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postScheduledBillingAccountChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const putScheduledBillingAccountChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getSupportCaseHistoryPrivateMethod = (supportCaseDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/support-cases/{supportCaseDisplayId}/history', {supportCaseDisplayId: supportCaseDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSupportCasePrivateMethod = (supportCaseDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/support-cases/{supportCaseDisplayId}', {supportCaseDisplayId: supportCaseDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSupportCasesPrivateMethod = (query?: SortableLimitableQuery & {  search?: string; feature?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createSupportCasePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenSupportCasesPrivateMethod = (query?: SortableLimitableQuery & {  search?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases/open-support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postFilePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/files',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createLeadPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/leads',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getSubscriptionsPrivateMethod = (query?: SortableLimitableQuery & {  subscriptionDisplayId?: string; subscriptionSubType?: string; contactId?: string; billingAccountId?: string; fetchOwnSubscriptionsOnly?: boolean; paymentType?: string; useSearchService?: boolean; deviceUser?: string; search?: string; expiringOrExpired?: boolean; subscriptionType?: string[]; subscriptionToken?: string; commitmentPeriod?: string; eppOnly?: boolean; eppFilter?: string; details?: boolean; expiringFilter?: string; reporting?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscriptions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSubscriptionPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getLocalUsagePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/local-usage', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getRoamingUsagePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/roaming-usage', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMonthlyUsageDetailsPrivateMethod = (month: string, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/usage-details/{month}', {month: month,subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const startBbfPrivateMethod = (subscriptionId: string, locale: string, portal: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/{locale}/{portal}/start-bbf', {subscriptionId: subscriptionId,locale: locale,portal: portal,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const startMfPrivateMethod = (subscriptionId: string, locale: string, portal: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/{locale}/{portal}/start-mf', {subscriptionId: subscriptionId,locale: locale,portal: portal,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const redeemOrTerminateEppPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/epp-redeem-terminate', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const maintenanceEppPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/epp-maintenance', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionBillingAccountPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-billing-account', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionUserInformationPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-user-information', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionTerminateDeviceServicePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/terminate-device-service', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionChangeSimPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-sim', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionSuspendPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/suspend', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionResumePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/resume', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionTerminatePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/terminate', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionFeaturesPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-features', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionMobilePbxPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-mobile-pbx', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionMobilePbxSolutionPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-mobile-pbx-solution', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeOwnerAccountPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-owner', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getSubscriptionScheduledChangePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/scheduled-changes', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const putSubscriptionScheduledChangePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/scheduled-changes', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getSubscriptionAggregationsPrivateMethod = (query: {  subscriptionCategory: string; excludeCardPayment?: boolean; excludeEpp?: boolean; search?: string; billingAccountRecordType?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscription-aggregations' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const hasPendingSubscriptionActionsPrivateMethod = (query: {  subscriptionDisplayId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/pending-subscription-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getWarrantyReceiptPdfPrivateMethod = (deliveryOrderId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/warranty-receipts/{deliveryOrderId}/pdf', {deliveryOrderId: deliveryOrderId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createOnlineOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const searchForPickupPointPrivateMethod = (query: {  service: string; maxResults: string; postalCode: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/pickup-points' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCreditCheckResultPrivateMethod = (query: {  onlineOrderId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/credit-check' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCustomerOrdersPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; customerOrderDisplayId?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getUserCustomerOrdersPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; customerOrderDisplayId?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employee-customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCustomerOrderAdditionalInfoPrivateMethod = (customerOrderDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/customer-orders/{customerOrderDisplayId}/additional-info-for-approver', {customerOrderDisplayId: customerOrderDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOrderConfirmationPdfPrivateMethod = (customerOrderDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/order-confirmation/{customerOrderDisplayId}/pdf', {customerOrderDisplayId: customerOrderDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSubscriptionActionsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; own?: boolean; subscriptionActionDisplayId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscription-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getValidatePortablePrivateMethod = (query: {  msisdn: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/validate-portable' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const prereserveNumbersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/prereserve',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getNumberRangePrivateMethod = (rangeId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/resources/numbers/ranges/{rangeId}', {rangeId: rangeId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const generateNumbersPrivateMethod = (query: {  count: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/generate' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const validateAvailabilityOfNumbersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/validate-availability',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getValidateSimFreePrivateMethod = (query: {  iccidNumber: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/sims/validate-free' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const requestEmployeeOtpForPairingPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/request-otp-for-pairing',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const validateEmployeeOtpAndPairPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/validate-otp-and-pair',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createEmployeePersonBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateEmployeePersonBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const initiateEmployeeOnBoardingPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/onboard',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOnboardingRequestsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/onboarding-requests',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const reviewAsEmployerPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employers/review',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getInvoicesPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; invoiceDisplayId?: string; balanceRange?: string; openInvoicesOnly?: boolean; paidInvoicesOnly?: boolean; skipBillingAccounts?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/invoices' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const initializeInvoicePaymentPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/initialize-payment', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const finalizeInvoicePaymentPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/finalize-payment', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getInvoicePrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getInvoicePdfPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/pdf', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDocumentsPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; documentType?: string[]; skipBillingAccounts?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/invoices/documents' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDocumentPrivateMethod = (invoiceDocumentId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/documents/{invoiceDocumentId}', {invoiceDocumentId: invoiceDocumentId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getInvoiceDocumentPdfPrivateMethod = (invoiceDocumentId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/documents/{invoiceDocumentId}/pdf', {invoiceDocumentId: invoiceDocumentId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const searchAddressPrivateMethod = (query: {  query: string; postalCode?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/addresses/search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordsHistoryPrivateMethod = (subscriptionId: string, query?: {  nextCursor?: string; sortOrder?: string; limit?: number; sortField?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/history', {subscriptionId: subscriptionId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordHistoryPrivateMethod = (historyId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/history/{historyId}', {historyId: String(historyId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordsPrivateMethod = (subscriptionId: string, query?: {  nextCursor?: string; sortOrder?: string; limit?: number; sortField?: string; type?: string[]; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records', {subscriptionId: subscriptionId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createDnsRecordPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateDnsRecordPrivateMethod = (recordId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records/{recordId}', {recordId: String(recordId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const deleteDnsRecordPrivateMethod = (recordId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records/{recordId}', {recordId: String(recordId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const validateAuxiliaryEsimOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auxiliary-esim-orders/validate',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postAuxiliaryEsimOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auxiliary-esim-orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getVirtualCatalogsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createVirtualCatalogPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const replaceVirtualCatalogsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs/replace',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getVirtualCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const deprecateVirtualCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const createDraftCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateDraftCatalogPrivateMethod = (virtualCatalogCode: string, catalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft/{catalogCode}', {virtualCatalogCode: virtualCatalogCode,catalogCode: catalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const deleteDraftCatalogPrivateMethod = (virtualCatalogCode: string, catalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft/{catalogCode}', {virtualCatalogCode: virtualCatalogCode,catalogCode: catalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const publishDraftCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/publish-draft', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getReportsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/reports',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getGeneratedReportPrivateMethod = (reportId: string, query: {  onlineReportId: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/reports/{reportId}', {reportId: reportId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const generateReportPrivateMethod = (reportId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/reports/{reportId}', {reportId: reportId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postPunchoutOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/punchout/orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getContractsPrivateMethod = (query?: {  contractDisplayId?: string; mdmId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contracts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postContractPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contracts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postTerminateContractPrivateMethod = (contractDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contracts/{contractDisplayId}/terminate', {contractDisplayId: contractDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getDeliveryMethodsPrivateMethod = (query?: {  productType?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/delivery-methods' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postServiceFeePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/service-fee',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getAddOnVisibilityPrivateMethod = (commercialProductCode: string, query: {  operationType: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/addon-visibility/{commercialProductCode}', {commercialProductCode: commercialProductCode,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const globalSearchPrivateMethod = (query: {  query: string; searchType?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/global-search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const licenseManagementUrlPrivateMethod = (query: {  accountId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/get-license-management-url' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getLicenseManagementAccountsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/get-license-management-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postCreateInterworksAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/create-interworks-account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormAddressPrivateMethod = (query: {  addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/address' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormProductAvailabilityPrivateMethod = (query: {  formId: string; subscriptionTypes: string[]; addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/product-availability' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const deleteOpenFormDraftsPrivateMethod = (query: {  referenceNumbers: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getOpenFormDraftItemListPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postOpenFormDraftPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormDraftPrivateMethod = (referenceNumber: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/openform/draft/{referenceNumber}', {referenceNumber: referenceNumber,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormPrivateMethod = (query: {  formId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/form' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postOpenFormCustomerNeedPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/form',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormItemListPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/list',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormSummaryPrivateMethod = (query: {  choices: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/summary' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormContactDetailsPrivateMethod = (query: {  contactIds: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/contact-details' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const parameterizedSearchContactsPrivateMethod = (query: {  searchTerm: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/parameterized-search/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMfaDetailsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/mfa/details',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const enableMfaPrivateMethod = (serviceAgreementId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/mfa/enable/{serviceAgreementId}', {serviceAgreementId: serviceAgreementId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOmalaskuStatusPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const activateOmalaskuPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const cancelOmalaskuPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getEligibleProductOffersForOfferTypePublicMethod = (offerType: string, query?: {  brand?: string; priceRange?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/public/productOffers/{offerType}', {offerType: offerType,}) + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductOfferingByIdPublicMethod = (offerId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/public/productOffer/{offerId}', {offerId: offerId,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getRelatedOffersPublicMethod = (offerId: string, query?: {  eppOfferId?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v4/public/productOffer/{offerId}/relatedOffers', {offerId: offerId,}) + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductOffersByOfferIdPublicMethod = (query: {  offerId: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v4/public/productOffers' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

